import { FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  applyFilters,
  selectors as filterSelectors,
} from "../../state/filters";
import { selectors as settingsSelectors } from "../../state/settings";
import { darkTheme, lightTheme } from "../../Style/theme";
import { FilterIcon } from "../../svgComponents";
import GridTable from "../GridTable";
import Headline from "../Headline";

const Widget = styled.div`
  background: ${({ theme }) => theme.colors.background};
  padding: ${({ theme }) => theme.spacings.small} 0;
  display: flex;
  flex-direction: column;
`;

const FilterContainer = styled.div`
  padding: 0 ${({ theme }) => theme.spacings.medium};
  svg {
    cursor: pointer;
  }
`;

const Spacer = styled.div`
  height: ${({ theme }) => theme.spacings.medium};
  width: 1px;
`;

const WidgetDisplay: FunctionComponent = () => {
  const dispatch = useDispatch();
  const hasFiltersApplied = useSelector(filterSelectors.getHasFiltersApplied);
  const { darkMode } = useSelector(settingsSelectors.getAllSettings);

  const theme = darkMode ? darkTheme : lightTheme;
  const svgColor = theme.colors.text;

  return (
    <Widget>
      <Headline svgColor={svgColor} />
      <FilterContainer>
        {hasFiltersApplied ? (
          <FilterIcon
            color={svgColor}
            onClick={() => dispatch(applyFilters(false))}
          />
        ) : (
          <Spacer />
        )}
      </FilterContainer>
      <GridTable svgColor={svgColor} />
    </Widget>
  );
};

export default WidgetDisplay;
